<span class="badge badge--{{ color }}" [ngClass]="{ 'badge--compact': compact }">
  <span class="badge__content badge__content--{{ modifier }}" [ngClass]="{ 'badge__content--compact': compact }">
    <ftr-icon *ngIf="icon" [icon]="icon" size="Small" align="Sub"></ftr-icon>
    <span
      class="badge__text"
      [ngClass]="{ 'badge__text--grey-color': greyTextColor, 'badge__text--compact': compact }"
      *ngIf="text"
      >{{ text }}</span
    >
  </span>
</span>
